import { createContext } from 'react'

// IepWizardContext holds various functions and values for coordinating overall wizard state and actions.
const IepWizardContext = createContext({
  closePath: () => {}, // Navigates to the close route.
  setBack: backRoute => {}, // Sets the path for the previous step (the back button does not appear if this is falsy).
  setProgress: progressValue => {}, // Sets the amount of progress reprsented by this step.
  setTitle: title => {}, // Sets the title of the current step.
  isNavigatorOrSuperuser: false,
  extractionData: null,
  setExtractionData: () => {},
  hideAIRecommendations: false // when true, hide the AI recommendations and show just the text extraction of the doc. e.g IEP/504 in AAM.
})

// IepAccessContext lets a host page override IEP access for everything beneath it.
const IepAccessContext = createContext({
  canAccessIep: undefined, // When defined, replaces the access the user’s capabilities would grant.
  // Runs addNote now, or later once the host has granted note access. Because that can be much later, addNote
  // must not rely on state captured when it was handed over; read current values (e.g., through a ref) instead.
  runWithNoteAccess: addNote => addNote()
})

export { IepAccessContext, IepWizardContext }
